export const DELETE_IMAGE='DELETE_IMAGE'
export const DELETE_IMAGE_SUCCESS= 'DELETE_IMAGE_SUCCESS'
export const DELETE_IMAGE_ERROR= 'DELETE_IMAGE_ERROR'

export const DeleteImage= (data) => ({
    type: DELETE_IMAGE,
    payload: data
})